<template>
  <div>
    <div class="d-flex justify-center">
      <v-slide-group
        show-arrows
        mandatory
        color="blue-dark"
        v-model="selected"
        class="mb-3"
      >
        <v-slide-item
          v-for="n in templatesOptions"
          :key="n.value"
          v-slot="{ active, toggle }"
        >
          <v-tooltip
            max-width="200"
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="mx-2 letter-spacing-0"
                :input-value="active"
                active-class="boton-color-talana white--text"
                depressed
                rounded
                @click="toggle"
              >
                {{ n.value }}
              </v-btn>
            </template>
            <span>{{ tabTooltip[n.value] }}</span>
          </v-tooltip>
        </v-slide-item>
      </v-slide-group>
    </div>

    <kf-assignment-template
      v-if="selected === 0 && kfTemplates"
      :kf-templates="kfTemplates"
      :category="1"
      :company="company"
      @update="getTemplates"
    />
    <kf-pending-template
      v-if="selected === 1 && kfTemplates"
      :kf-templates="kfTemplates"
      :category="2"
      :company="company"
      @update="getTemplates"
    />
    <kf-expiration-template
      v-if="selected === 2 && kfTemplates"
      :kf-templates="kfTemplates"
      :category="3"
      :company="company"
      @update="getTemplates"
    />
    <kf-answered-template
      v-if="selected === 3 && kfTemplates"
      :kf-templates="kfTemplates"
      :category="4"
      :company="company"
      @update="getTemplates"
    />
  </div>
</template>

<script>
import KfAssignmentTemplate from './components/assignment-template.vue';
import KfExpirationTemplate from './components/expiration-template.vue';
import KfPendingTemplate from './components/pending-template.vue';
import KfAnsweredTemplate from './components/answered-template.vue';
import { getKfEmailTemplates } from '@app/modules/keyform/services/email-templates.service';

export default {
  components: {
    KfAssignmentTemplate,
    KfExpirationTemplate,
    KfPendingTemplate,
    KfAnsweredTemplate,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      templatesOptions: [
        { value: 'Asignación' },
        { value: 'Recordatorio' },
        { value: 'Expiración' },
        { value: 'Rendido' },
      ],
      selected: null,
      kfTemplates: null,
      tabTooltip: {
        'Asignación': `Se enviará a tus postulantes para informarles que tienen una nueva
          solicitud por realizar dentro de tu proceso`,
        'Recordatorio': `Funciona a modo de recordatorio, para postulantes que tengan una solicitud
          pendiente aún no realizada.`,
        'Expiración': `Transcurridos los días de vigencia que elegiste, este correo informa que la
          solicitud pendiente ya no puede ser realizada.`,
        'Rendido': 'Tras la realización de la solucitud, el postulante será informado que la recibiste.',
      },
    };
  },
  methods: {
    getTemplates() {
      getKfEmailTemplates()
        .then((res) => {
          this.kfTemplates = res?.emailTemplates;
        });
    },
  },
  beforeMount() {
    this.getTemplates();
  },
};
</script>

<style>

</style>
